// eslint-disable-next-line no-irregular-whitespace
export const ADVERTISING_LABELING_TEXT = `Справочный каталог. Cправочно-информационные и аналитические материалы о риелторах предоставляют пользователи Циан. Также мы используем данные иных открытых источников с целью обзора внутреннего рынка.`;
